import { useNavigate } from "react-router-dom";
import { formatAuthors } from "../util/books";
import { getRatingClasses } from "../util/ratings";

export const BookCard = ({ book }) => {
  const navigate = useNavigate();
  const handleClick = () => navigate(`/books/${book.sid}`, { state: { book } });

  return (
    <li
      onClick={handleClick}
      className="card p-4 cursor-pointer hover:border-teal-600"
    >
      <div className="flex items-start justify-between gap-3">
        <div className="min-w-0">
          <div className="font-medium text-stone-800 truncate">
            {book?.title}
          </div>
          <div className="text-sm text-stone-500 truncate">
            {formatAuthors(book?.authors)}
          </div>
          <div className="text-sm text-stone-500">{book?.dateRead}</div>
        </div>
        <span className={`badge shrink-0 ${getRatingClasses(book?.rating)}`}>
          {book?.rating?.description}
        </span>
      </div>
    </li>
  );
};

const BookRow = ({ book }) => {
  const navigate = useNavigate();
  const handleRowClick = () => navigate(`/books/${book.sid}`, { state: { book } });

  return (
    <tr onClick={handleRowClick} className="cursor-pointer hover:bg-stone-100">
      <td className="px-3 py-2">{book?.title}</td>
      <td className="px-3 py-2">{formatAuthors(book?.authors)}</td>
      <td className="px-3 py-2">{book?.dateRead}</td>
      <td className="px-3 py-2">
        <span className={`badge ${getRatingClasses(book?.rating)}`}>
          {book?.rating?.description}
        </span>
      </td>
    </tr>
  );
};

export default BookRow;
